import { SERVICE_DESK_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	MULTI_USER_PICKER_GQL_FIELD,
	APPROVERS_LIST_CF_TYPE,
	PEOPLE_CF_TYPE,
	MULTI_USER_CF_TYPE,
	PARTICIPANTS_CF_TYPE,
	REQUEST_PARTICIPANTS_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { getProjectType } from './project-field-transformer.tsx';
import { transformJiraUserToLegacyServerUser } from './user-node-transformer.tsx';
import {
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

export const transformAggMultipleUserPickerToLegacyField: FieldTransformer = (
	node,
	projectContext,
) => {
	const value = transformAggConnection(
		node.selectedUsersConnection,
		transformJiraUserToLegacyServerUser,
	);

	const legacyFieldValues = {
		...transformAggNodeToLegacyField(node),
		value: value.length > 0 ? value : null,
		schema: {
			configuration: null,
			custom: node.type,
			items: 'user' as const,
			renderer: PLAIN_TEXT,
			system: null,
			type: 'array',
		},
	};

	switch (node.type) {
		case REQUEST_PARTICIPANTS_CF_TYPE: {
			if (node.__typename === MULTI_USER_PICKER_GQL_FIELD) {
				return {
					...legacyFieldValues,
					value,
				};
			}

			if (getProjectType(projectContext?.projectType) !== SERVICE_DESK_PROJECT) return undefined;
			// Empty array is the expected value when there are no request
			// participants.
			return {
				...legacyFieldValues,
				value,
			};
		}
		case PARTICIPANTS_CF_TYPE:
		case MULTI_USER_CF_TYPE:
			return legacyFieldValues;
		case APPROVERS_LIST_CF_TYPE:
		case PEOPLE_CF_TYPE: {
			const schemaConfig =
				'isMulti' in node && node.isMulti != null
					? [{ key: 'isMulti', value: String(node.isMulti) }]
					: null;

			return {
				...legacyFieldValues,
				autoCompleteUrl: node.searchUrl,
				schema: {
					...legacyFieldValues.schema,
					configuration: schemaConfig,
				},
			};
		}
		default:
			return undefined;
	}
};
